import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin-bottom: auto;
  padding-top: 32px;
  gap: 10px;
`;
